import { z } from "zod";

import { constantsData } from "@/data";

export const signupFormSchema = z.object({
    confirmPassword: z.string().min(
        6,
        { message: constantsData.msgs.minPassword },
    ),
    email: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ).email(constantsData.msgs.notValidEmail),
    fullName: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    image: z.any(),
    password: z.string().min(
        6,
        { message: constantsData.msgs.minPassword },
    ),
}).superRefine(({
    confirmPassword,
    password,
}, ctx) => {
    if (confirmPassword !== password) {
        ctx.addIssue({
            code: "custom",
            message: constantsData.msgs.passwordNotMatch,
            path: ["confirmPassword"],
        });
    }
});
